"use client"

import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function AOSProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true, // Animation happens only once
      offset: 100, // Offset from the original trigger point
      easing: 'ease-in-out',
    })
    
    // Refresh AOS on route changes (for Next.js)
    AOS.refresh()
  }, [])

  return <>{children}</>
}